//请自行添加语言资源
const transportPlan = {
  companyName: '所属机构',
  planNo: '运输计划单号',
  soOrSto: '客户相关单号',
  reqDispatchDate: '要求发货时间',
  transModel: '运输模式',
  transType: '运输方式',
  reqArriverDate: '要求送达时间',
  carrierName: '承运商',
  statusName: '调度单状态',
  truckNo: '车牌号',
  plateColor: '颜色',
  truckTypeName: '车型',
  driverName: '司机',
  driverIdcard: '司机驾驶证',
  driverTel: '司机电话',
  totalQty: '总箱数',
  totalWeight: '总毛重(Kg)',
  totalNetWeight: '总净重(Kg)',
  totalVolume: '总体积(m³)',
  originAddrProvinceName: '发货省份',
  originAddrCityName: '发货城市',
  originAddrDistrictName: '发货区/县',
  destAddrProvinceName: '收货省份',
  destAddrCityName: '收货城市',
  destAddrDistrictName: '收货区/县',
  currLocation:'当前位置',
  dispatchUserNo: '发运操作用户',
  dispatchTime: '发运时间',
  dispatchOperationTime: '发运操作时间',
  dispatchRemark: '发运备注',
  deliverUserNo: '送达操作用户',
  deliverTime: '送达时间',
  deliverOperationTime: '送达操作时间',
  deliverRemark: '送达备注',
  planPickupDateTime: '预计提货时间',
  planPickupDate: '预计提货日期',
  planPickupTime: '预计提货时间',
  outPlanNo: '运输计划单号(外部)',
  dealResult: '反馈信息',

  orderNo: 'TMS单号',
  schOrderNo: '作业单号',
  customerOrderNo: '客户订单号',
  schOrderTypeName: '作业类型',
  shipperName: '货主',
  orderType: '订单类型',
  orderDate:'订单日期',
  originAddrName: '发货方',
  originAddrContactMan: '发货人',
  originAddrContactTel: '发货人电话',
  originAddrLocation: '发货地址',
  destAddrName: '收货方',
  destAddrContactMan: '收货人',
  destAddrContactTel: '收货人电话',
  destAddrLocation: '收货地址',
  remark: '备注',
  seqType: '备货类型',
  seq: '序号',
  loadWeight: '核载重量',
  loadVolume: '核载体积',
  driverLicense: '驾驶证',
  orderProperty: '订单属性',
  orderClassify: '订单分类',
  appointmentDate: '预约日期',
  segment: '时间段',
  maxLoad: ' 最大装货量（m³)',
  surplusVol: '剩余装货量（m³）',
  gpsFlag: '需要获取轨迹',
  expressNo: '快递单号',
  expressFlag: '是否快递单',
  msg:{
    truckNo: '请输入车牌号',
    plateColor: '请输入车牌颜色',
    driverName: '请输入司机姓名',
    mobile: '请输入手机号',
    carrierName: '请选择承运商',
    transType: '请选择运输方式',
    truckType: '请选择车辆类型',
    loadWeight: '请输入核载重量',
    loadVolume: '请输入核载体积',
  },
  receiveAddressName: '收货方'
};
export default transportPlan



// WEBPACK FOOTER //
// ./src/page/transport/transportPlan/lang/transportPlan.zh.js